import React from "react";

export function EmptyState({ label = "No data for this selection" }) {
  return <div className="flex-1 flex items-center justify-center text-xs text-slate-400 py-12">{label}</div>;
}